import { render, staticRenderFns } from "./Mm1Footer.vue?vue&type=template&id=98fc718e&scoped=true&"
import script from "./Mm1Footer.vue?vue&type=script&lang=ts&"
export * from "./Mm1Footer.vue?vue&type=script&lang=ts&"
import style0 from "./Mm1Footer.vue?vue&type=style&index=0&id=98fc718e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98fc718e",
  null
  
)

export default component.exports